module.exports = __webpack_public_path__ + "img/2.ff89aa67.png";